import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommitAvatarComponent } from './commit-avatar.component';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    RouterModule
  ],
  declarations: [
    CommitAvatarComponent
  ],
  exports: [
    CommitAvatarComponent
  ]
})
export class CommitAvatarModule { }
